// extracted by mini-css-extract-plugin
export default {"complianceHistoryTable":"V4GTn3qC2oIG_SLm3qvX"};